import axiosDispatch from './../axios/dispatch';

export function transactionsSearch(params = {}) {
  return dispatch => {
    return axiosDispatch(dispatch, '/transactions/searchByUser', params);
  }
}